import {NAMESPACE} from '../constants';

const Globalized = {
  createGlobal(namespace) {
    var nso = window;

    if (!namespace) {return undefined;}

    namespace.split('.').forEach((prop) => {
      nso[prop] = nso[prop] || {};
      nso = nso[prop];
    });

    return nso;
  },

  lookup(namespace = NAMESPACE, root = window) {
    return namespace.split('.').reduce((that, o) => {
      return that && o in that ? that[o] : {};
    }, root);
  }
};

export default Globalized;



// WEBPACK FOOTER //
// ./src/mixins/globalized.js